/**
 * Save a file the user asked for: the native Save As on desktop (opened over
 * the window that asked, the file written by the app), a browser download on
 * the web. Resolves false when the user cancels; a failed save rejects with
 * the reason.
 */
import { invoke } from "@tauri-apps/api/core";
import { isTauri } from "./is-tauri";

export async function saveFile(
  blob: Blob,
  fileName: string,
  extension: string,
): Promise<boolean> {
  if (isTauri()) {
    try {
      return await invoke<boolean>(
        "save_file",
        new Uint8Array(await blob.arrayBuffer()),
        {
          headers: {
            "x-file-name": encodeURIComponent(fileName),
            "x-file-extension": encodeURIComponent(extension),
          },
        },
      );
    } catch (error) {
      // Commands reject with the reason as a string.
      throw error instanceof Error ? error : new Error(String(error));
    }
  }

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return true;
}
